import React, { FC } from 'react';
import css from './TagsShields.module.scss';

export const TagsShields: FC<{ tags: string[] }> = ({ tags }: { tags: string[] }) => (
    <div className={css.tagsShieldsRoot}>
        {tags.map((tag: string) => (
            <div
                className={`other-shield-caps-semibold ${css.tagsShieldsItem}`}
                key={tag}
            >
                {tag}
            </div>
        ))}
    </div>
);
